<template>
    <Modal :id="'ticket_historico'" :size="''" :open="show" :FooterDefault="false" :ClassBG="true" :customModalBody="'padding-top:5px;'" :customModalMain="'z-index:100000'">      
        <template v-slot:header>
            <h6 class="modal-title">Histórico do Ticket</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="fecharModal()">
                <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
            </button>
        </template>
        <template v-slot:body>
            <div>                
                <h3 style="margin-top: 8px; margin-bottom: -8px;"><i class="fas fa-list-alt"></i> Histórico de Etapas</h3>
                <DataTable v-if="url_etapas != ''" :url_ajax="url_etapas" :ajax_set_result="setResult" @grid_refreshed="gridRefreshed_etapas" :refresh="refresh_grid_etapas" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="false" :footer_fixed="false" :is_NotLoading="true" :request_api="'comercial'">
                    <template v-slot:rows="{ rows }">
                        <div class="container-fluid" style="overflow-x: auto;">
                            <div class="timeline-wrapper">
                                <div class="timeline">
                                    <div class="event" v-for="etapa in rows" :key="etapa.cdSetorClassificacaoEtapa">
                                        <span>{{ etapa.nmSetorClassificacao }}</span>
                                        <p/><span  style="font-weight:600;">{{ etapa.nmSetorClassificacaoEtapa }}</span>
                                        <p>{{ etapa.dtInclusao }}</p>
                                        <p>{{ etapa.dsLoginConsultor }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </DataTable>
                <div class="row mt-3">
                    <div class="col-6">
                        <h3><i class="far fa-clock"></i> Histórico de Açoes</h3>
                        <DataTable v-if="url_movimentacoes != ''" :url_ajax="url_movimentacoes" :ajax_set_result="setResult" @grid_refreshed="gridRefreshed_movimentacoes" :refresh="refresh_grid_movimentacoes" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="false" :is_NotLoading="true" :headers="headers_movimentacoes" :customHeight="'max-height: calc(100vh - 27.5rem) !important;'"  lineHeigthProp="line-height: 30px;" :request_api="'comercial'">
                        </DataTable>
                    </div>
                    <div class="col-6">
                        <h3><i class="fas fa-tasks"></i> Histórico de Tarefas Realizadas</h3>
                        <DataTable v-if="url_tarefas != ''" :url_ajax="url_tarefas" :ajax_set_result="setResult" @grid_refreshed="gridRefreshed_tarefas" :refresh="refresh_grid_tarefas" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="false" :is_NotLoading="true" :headers="headers_tarefas" :customHeight="'max-height: calc(100vh - 27.5rem) !important;'" lineHeigthProp="line-height: 30px;" :request_api="'comercial'">
                        </DataTable>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal">
                    Fechar
                </button>
            </div>
        </template>
    </Modal>
</template>

<script>

    import Modal from "@/components/App/Modal.vue";
    import DataTable from "@/components/App/Datatable.vue";

    export default {
        name: "Ticket_Historico",
        components: {
            Modal,
            DataTable
        },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                url_etapas: '',
                url_movimentacoes: '',
                url_tarefas: '',
                refresh_grid_etapas: false,
                refresh_grid_movimentacoes: false,
                refresh_grid_tarefas: false,
                filtro: [{ active: true }],
                headers_movimentacoes: [
                    {
                        class: "col-2",
                        name: "dtInclusao",
                        text: "Data"
                    },
                    {
                        class: "col-7",
                        name: "dsMovimento",
                        text: "Movimento"
                    },
                    {
                        class: "col-3",
                        name: "dsLoginConsultor",
                        text: "Consultor"
                    },
                ],
                headers_tarefas: [
                    {
                        class: "col-3",
                        name: "nmTarefa",
                        text: "Tarefa"
                    },
                    {
                        class: "col-5",
                        name: "dsObservacao",
                        text: "Parecer"
                    },
                    {
                        class: "col-2",
                        name: "dtRealizacao",
                        text: "Realização"
                    },
                    {
                        class: "col-2",
                        name: "dsLoginConsultor",
                        text: "Consultor"
                    }
                ],
            }
        },
        mounted() { },
        methods: {
            setResult(result) {
                return result;
            },
            gridRefreshed_etapas(data_ajax) {
                let $this = this;
                $this.refresh_grid_etapas = false;
            },
            gridRefreshed_movimentacoes(data_ajax) {
                let $this = this;
                $this.refresh_grid_movimentacoes = false;
            },
            gridRefreshed_tarefas(data_ajax) {
                let $this = this;
                $this.refresh_grid_tarefas = false;
            },
            refreshModal() {
                this.refresh_grid_etapas = true;
                this.refresh_grid_movimentacoes = true;
                this.refresh_grid_tarefas = true;
            }
        },
        watch: {
            idOcorrencia(new_value, old_value) {
                this.url_etapas = process.env.VUE_APP_ROOT_COMERCIAL_API + '/OcorrenciaMovimento/Get?flEtapas=true&idOcorrencia=' + new_value + '&';
                this.refresh_grid_etapas = true;

                this.url_movimentacoes = process.env.VUE_APP_ROOT_COMERCIAL_API + '/OcorrenciaMovimento/Get?flEtapas=false&idOcorrencia=' + new_value + '&';
                this.refresh_grid_movimentacoes = true;

                this.url_tarefas = process.env.VUE_APP_ROOT_COMERCIAL_API + '/OcorrenciaTarefa/Get?idOcorrencia=' + new_value + '&';
                this.refresh_grid_tarefas = true;
            },
        }
    };

</script>

<style lang="scss" scoped>

    h3 {
        color: #434343;
        font-size: 15px;
        font-family: Inter;
        font-weight: 500;
    }

    $blue: #9F3029;

    .timeline-wrapper {
        position: relative;
    }

    .timeline {
        display: flex;
        transition: all 0.3s;
        justify-content: center;
        padding-bottom: 15px;
        border-bottom: 10px solid $blue;
        margin: 0 0 50px 0;

        .event {
            min-width: 220px;
            max-height: 105px;
            background: lighten($blue, 50);
            padding: 1em;
            border-radius: 5px;
            position: relative;
            margin: 0 1em 0 1em;
            transition: all 0.3s;
            box-shadow: 0 0 5px #ccc;
            color: darken($blue, 20);
            text-align: center;

            p {
                color: $blue;
            }

            * {
                padding: 0;
                margin: 0;
            }

            &::after {
                margin: 0 auto;
                position: relative;
                bottom: -40px;
                content: "";
                display: block;
                border-radius: 15px;
                height: 30px;
                width: 30px;
                box-sizing: border-box;
                box-shadow: 0 0 5px darken($blue, 10);
                background: #fff;
                border: 5px solid $blue;
                transition: all 0.25s;
                z-index: 2;
            }
        }
    }

</style>